import React, { useState } from 'react';
import isEmpty from 'lodash.isempty';
import { Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import api from '../../../actions/EndPoints';
import axiosInstance from '../../../actions/AxiosInstance';
import {
    engagementType,
    getIsRasHH,
    setLastRequestTime,
    log,
    scrollTo,
    resetErrState,
    showModal,
    closeModal
} from '../../../Utils';
import { dispatchOverlayLoad } from '../../shared/Analytics';
import AccountSelectionContent from './AccountSelectionContent';
import { PsBeaconButton, PsBeaconIcon, PsBeaconModal } from '../../shared/BeaconRegister';
import { GENERAL_HUB_ERROR_MODAL, HUB_GENERAL_ERROR_OVERLAY } from '../../../Constants';

const AccountSelectionPageModal = ({ state, dispatch }) => {
    const numberOfClients = state?.numberOfClients;
    const apiKey = state?.apiKey;
    const planningGroup = state?.planningGroup;
    const engagementStatus = state?.engagementStatus;
    const isRegisteredUser = state?.isRegisteredUser;
    const isPrimary = state?.isPrimary;

    const isRasHH = getIsRasHH(planningGroup, engagementStatus);
    const checkIfCoClient =
        window.location.pathname.indexOf('co-client-consent') !== -1 &&
        window.location.pathname.indexOf('reenroll') === -1;
    const showYodleeConsent =
        isRegisteredUser && !checkIfCoClient && (numberOfClients > 0 ? isPrimary : true);
    const getEngagementType = engagementType(isRasHH, isPrimary);
    const [inProgress, setConsentInProgress] = useState(false);

    const [checkState, setCheckState] = useState({
        checked401k: false,
        checkedTrust: false,
        checkedYodlee: false,
        checkedConfirmation: false,
    });

    const hasConfirmedCheck = () => {
        const reviewCheckbox = document?.querySelectorAll(`#checkedConfirmation`)[0];
        reviewCheckbox?.checkValidity();
        if (reviewCheckbox?.checkValidity()) {
            resetErrState(reviewCheckbox);
        }
    };

    const handleChange = (name) => (event) => {
        log(console.log(event.target.checked, name));
        hasConfirmedCheck();
        setCheckState({ ...checkState, [name]: event.target.checked });
    };

    const accountSelectionAction = state?.activeActions?.filter(
        (action) => action.actionType === 'ACCOUNT_SELECTION'
    );

    const headerPayload = {
        consent401k: checkState.checked401k,
        consentYodleeIndicator: checkState.checkedYodlee,
        consentTrust: checkState.checkedTrust,
        engagementType: getEngagementType,
        consentEDelivery: null,
    };

    async function updateActionConsent() {
        setConsentInProgress(true);
        const financialPlanningActionId =
            state.activeActions && !isEmpty(accountSelectionAction)
                ? accountSelectionAction[0].financialPlanningActionId
                : null;
        const updatedPayload = { ...headerPayload, financialPlanningActionId };
        await axiosInstance
            .put(api.consentAPI, updatedPayload, {
                headers: {
                    apikey: `${apiKey}`,
                },
            })
            .then((res) => {
                if (res) {
                    setLastRequestTime();
                    dispatch({
                        type: 'CONSENT_UPDATED',
                        isConsented: true,
                    });
                }
            })
            .catch((error) => {
                // If co-client started invitation flow and status is updated to PLDL / url expired
                const showErrorModalPromise = Promise.resolve(showModal(GENERAL_HUB_ERROR_MODAL));
                showErrorModalPromise
                    .then(() => console.log(error))
                    .then(() => dispatchOverlayLoad(HUB_GENERAL_ERROR_OVERLAY))
                    .then(() => setConsentInProgress(false))
                    .then(() => setLastRequestTime());
            });
    }

    async function updateConsent() {
        setConsentInProgress(true);
        await axiosInstance
            .post(api.consentAPI, headerPayload, {
                headers: {
                    apikey: `${apiKey}`,
                },
            })
            .then((res) => {
                if (res) {
                    setLastRequestTime();
                    dispatch({
                        type: 'CONSENT_UPDATED',
                        isConsented: true,
                    });

                        setConsentInProgress(false);
                        window.location.replace('/usis/advice/fps/profile');

                }
            })
            .catch((error) => {
                const showErrorModalPromise = Promise.resolve(showModal(GENERAL_HUB_ERROR_MODAL));
                showErrorModalPromise
                    .then(() => console.log(error))
                    .then(() => dispatchOverlayLoad(HUB_GENERAL_ERROR_OVERLAY))
                    .then(() => setConsentInProgress(false))
                    .then(() => setLastRequestTime());
            });
    }

    const handleOnClick = () => {
        const getCorrectConsent = !isEmpty(state.activeActions)
            ? updateActionConsent
            : updateConsent;
        if (checkState.checkedConfirmation) {
            getCorrectConsent()
            .then(() => closeModal('acct-selection'));
        } else {
            hasConfirmedCheck();
            scrollTo('review-checkbox-control');
        }
    };

    const props = {
        showYodleeConsent,
        checkState,
        handleChange,
    };

    return (
        <PsBeaconModal scale="jumbo" id="acct-selection">
            <AccountSelectionContent includeInvestmentContent {...props} />
            <Box
                slot="action-zone"
                id="continue-button-container"
                sx={{ display: 'flex', justifyContent: 'end' }}>
                <PsBeaconButton
                    id="continue-acc-sel-consent"
                    variant="primary"
                    onClick={handleOnClick}
                    disabled={inProgress || state?.isCustomerWebView}>
                    Continue
                    <PsBeaconIcon slot="suffix" name="chevron_right" />
                </PsBeaconButton>
            </Box>
        </PsBeaconModal>
    );
};

export default function AccountSelectionModal({ state, dispatch }) {
    return <AccountSelectionPageModal state={state} dispatch={dispatch} />;
}
